
  export default {
    name: 'NavigationDropdownMenu',
    props: {
      open: Boolean,
    },
  }
